import styled from 'styled-components';
import {
  CardHeader,
  CardImage,
  CardImageWrapper,
  ProductCard,
  ProductCardContent, ProductDescription,
  ProductTitle
} from './ProductCard';
import React, {useEffect} from 'react';
import css from '@styled-system/css';
import Cost, {Cents, Currency, Dollars} from '../../components/ui/Cost';
import {CTAButton} from '../../components/ui/Button';
import FlexList from '../../components/ui/FlexList';
import {Link} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {fetchProducts, selectAllProducts} from './productsSlice';
import {cartAdded} from '../cart/cartSlice';

export const Item = styled.div`
  ${css({
  padding: [3]
})}
  margin:0;
`


const Product = ({item}) => {
  const dispatch = useDispatch()

  return (
    <Item>
      <ProductCard>
        <CardImageWrapper>
          <CardImage style={{objectFit: 'cover' }} src={item.image}/>
        </CardImageWrapper>
        <ProductCardContent>
          <CardHeader>
            <ProductTitle>
              <Link to={`/product/${item.sku}`}>{item.name}</Link>
            </ProductTitle>
            <Cost>
              <Currency>$</Currency>
              <Dollars>{Math.trunc(item.price)}</Dollars>
              <Cents>{(item.price % 1).toFixed(2).substring(2)}</Cents>
            </Cost>
          </CardHeader>
          <ProductDescription>
            {item.description}
          </ProductDescription>
          <CTAButton onClick={() => dispatch(cartAdded(item))}>
            Add to Cart
          </CTAButton>
        </ProductCardContent>
      </ProductCard>
    </Item>
  )
}

export default function ProductList() {
  //const { products } = useProducts()
  const dispatch = useDispatch()
  const products = useSelector(selectAllProducts)

  const productStatus = useSelector(state => state.products.status)
  const productError = useSelector(state => state.products.error)

  useEffect(() => {
    if(productStatus === 'idle') {
      dispatch(fetchProducts())
    }
  }, [productStatus, dispatch])

  return (
      <FlexList marginTop='2em'
        data = { products }
        Comp = { Product }
        status = { productStatus }
        error = { productError }
      />
  )
}



// {products.map((product, index) => <Product key={index} />)}